<template lang="pug">
  span(:style="'background-color:' + bgColor + '; border-color:' + rgb + ';'")
    slot {{name}}
</template>

<script>
export default {
  name: 'TagColor',
  // 引数
  props: {
    rgb: {type: String, required: true, default: '#fff'}, // タグ色（必須）
    outline: {
      type: Boolean,
      required: false,
      default: false
    }, // アウトライン（個人タグはON）
    name: {
      type: String,
      required: false,
      default: ''
    }
  },
  computed: {
    bgColor: function () {
      return this.outline ? '#fff' : this.rgb
    }
  }
}
</script>

<style lang="scss" scoped>
span {
  min-width: 22px;
  min-height: 22px;

  border: 4px solid #fff;
  border-radius: 4px;
  display: inline-block;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/TagColor.vue